export default "__VITE_ASSET__ce8c8407__"